var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F4F7",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M21.875 12.5a2.625 2.625 0 0 1 2.372 3.751h2.503a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75H26v6a.75.75 0 0 1-.75.75h-10.5a.75.75 0 0 1-.75-.75v-6h-.75a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75h2.503A2.625 2.625 0 0 1 20 13.29a2.609 2.609 0 0 1 1.874-.788Zm2.625 8.25h-9V26h9v-5.25Zm1.5-3H14v1.5h12v-1.5ZM18.125 14a1.125 1.125 0 0 0-.108 2.245l.108.006h1.125v-1.125a1.125 1.125 0 0 0-1.017-1.12L18.125 14Zm3.75 0-.108.006a1.125 1.125 0 0 0-1.012 1.012l-.005.108v1.125h1.125l.108-.006a1.125 1.125 0 0 0 0-2.24l-.108-.004Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 11h18v18H11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.d8d3a1923f9b4deef663e67e3c83ba53.svg";
export { ForwardRef as ReactComponent };